<div id="loadingdiv" #loadingdiv [ngStyle]="{display: (this.loading ? 'block' : 'none')}"></div>
